import React, { useRef, useEffect, useState, useCallback } from "react";
import cep from "cep-promise";
import { format } from "date-fns";
import api from "../../services/api";

import errors, { IAliancaErrors } from "../../Utils/ExtractErrors";

import { Form, Modal, Button, Grid, Image, InputProps, Label, Input, TextArea, Icon, Checkbox, DropdownProps, InputOnChangeData, TabProps, Tab, Divider, TextAreaProps, Message, Segment, Select, Menu } from "semantic-ui-react";
import MaskedInput from "../../components/MaskedInput";
import MaskedInputNew from "../MaskedInput";
import { toast } from "react-toastify";

import ModalApp from "../ModalApp";
import ImageZoom from "../ImageZoom";

import ImagemRepository from "../../Repositories/ImagesRepository";
import NotificationRepository from "../../Repositories/NotificationRepository";

import { eStatus, INotificacao, IPessoa, eStatusKit, eEstado, eTipoKit } from "../../interfaces";
import ModalYesNo from "../ModalYesNo";
import { GetUser } from "../../services/auth";
import CadastroMotivoPendente, { INotificationPersons } from "./CadastroMotivoPentende";
import { getDescription } from "../../Utils/GetNotificationDescription";
import KitRepository, { IKitListModel } from "../../Repositories/KitRepository";
import AgentsRepository, { IAgentListModel } from "../../Repositories/AgentsRepository";
import CustomLoader from "../CustomLoader";
import numberFormat from "../../Utils/NumberFormat";
import EditarKit from "../../pages/Kits/EditarKit";
import resellersRepository from "../../Repositories/ResellersRepository";

interface IState extends IPessoa {
    gerenteRegionalId?: string;
    gerenteSetorId?: string;
    representanteId?: string;
    kitId?: string;
    notificacao: INotificacao;
    apiErrors: IAliancaErrors;
}

interface Props {
    id: string;
    open?: boolean;
    hideTrigger?: boolean;
    onSuccess: () => void;
    url: string;
}

const initialNotification: INotificacao = {
    id: "",
    criadaEm: "",
    criadaPor: "",
    descricao: "",
    mensagem: "",
    pessoaPendente: "",
    recebedores: []
}

const initialState: IState = {
    data: "",
    nome: "",
    consulta: "",
    celular: "",
    nascimento: "",
    cpf: "",
    rg: "",
    cep: "",
    numero: "",
    bairro: "",
    logradouro: "",
    complemento: "",
    cidade: "",
    uf: "",
    status: 1,
    devedor: 1,
    contrato: false,
    protestado: false,
    risco: false,
    crm: "",
    dataProtesto: undefined,
    documentos: [],
    notificacao: initialNotification,
    kitId: "",
    nomeReferencia1: "",
    celularReferencia1: "",
    parentescoReferencia1: "",
    nomeReferencia2: "",
    celularReferencia2: "",
    parentescoReferencia2: "",
    apiErrors: { errors: [] }
}

const EditarPessoa: React.FC<Props> = (props) => {

    const [open, setOpen] = useState<boolean>(!!props.open);
    const [loading, setLoading] = useState<boolean>(false);
    const [state, setState] = useState<IState>(initialState);
    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
    const [preview, setPreview] = useState<string[]>([]);
    const [kits, setKits] = useState<IKitListModel[]>([]);
    const [activeTabIndex, setActiveTabIndex] = useState<number>(0);
    const [agents, setAgents] = useState<IAgentListModel[]>([]);

    const fileInputRef = useRef<HTMLInputElement>(null);

    const { role } = GetUser();

    const load = useCallback(async () => {
        setLoading(true);

        try {
            const [pessoa, imagem, notificacao] = await Promise.all([
                api.get(props.url),
                ImagemRepository.GetByReferenceId(props.id),
                NotificationRepository.GetByPendingPersonId(props.id)
            ]);

            const response = await KitRepository.List({
                filter: `RevendedorId == "${pessoa.data.id}" && StatusKit >= 3`
            });
            setKits(response.list);


            setState(state => ({
                ...state,
                ...pessoa.data,
                documentos: imagem,
                nascimento: format(new Date(pessoa.data.nascimento), "dd/MM/yyyy"),
                dataProtesto: pessoa.data.dataProtesto && format(new Date(pessoa.data.dataProtesto), "dd/MM/yyyy"),
                notificacao: notificacao || initialNotification
            }));
            LoadAgents(toString() || "");

        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
        setLoading(false);
    }, [props.id, props.url])

    const onButtonClick = () => {
        if (fileInputRef && fileInputRef.current) {
            fileInputRef.current.click();
        }
    }
    const LoadAgents = useCallback(async (id: string) => {
        const result = await AgentsRepository.List({
            filter: `Status == 1`
        });

        setAgents(result.list);
    }, []);

    useEffect(() => {
        if (selectedFiles.length > 0) {
            let images: string[] = [];

            for (const file of selectedFiles) {
                images.push(URL.createObjectURL(file));
            }

            setPreview(preview => preview.concat(images));

            return () => {
                for (const image of images) { URL.revokeObjectURL(image) }
                setPreview([]);
            }
        }
    }, [selectedFiles])

    const onSelectFile = (e: any) => {
        if (!e.target.files || e.target.files.length === 0) {
            setSelectedFiles([])
            return

        }

        let files: File[] = [];
        files = files.concat(selectedFiles);

        for (const file of e.target.files) {
            files.push(file);
        }

        setSelectedFiles(files);
    }

    const onRemovePreview = (imageUrl: string, index: number) => {
        const images = preview.filter(x => x !== imageUrl);

        selectedFiles.splice(index, 1);

        URL.revokeObjectURL(imageUrl);
        setPreview(images);
    }

    const onRemove = async (id: string) => {
        await ImagemRepository.DeleteById(id);
        load();
    }

    const handleTabChange = useCallback((event: React.MouseEvent<HTMLDivElement, MouseEvent>, { activeIndex }: TabProps) => {
        setActiveTabIndex(activeIndex as number);
    }, []);

    const savePerson = async () => {
        const data = new FormData();

        data.append("nome", state.nome);
        data.append("consulta", state.consulta);
        data.append("celular", state.celular);
        data.append("nascimento", state.nascimento);
        data.append("cpf", state.cpf);
        data.append("rg", state.rg);
        data.append("cep", state.cep);
        data.append("numero", state.numero);
        data.append("bairro", state.bairro);
        data.append("logradouro", state.logradouro);
        data.append("complemento", state.complemento);
        data.append("cidade", state.cidade);
        data.append("uf", state.uf);
        data.append("status", state.status === eStatus.PreCadastro ? eStatus.Pendente.toString() : state.status.toString());
        data.append("devedor", state.devedor.toString());
        data.append("contrato", state.contrato.toString());
        data.append("risco", state.risco.toString());
        data.append("protestado", state.protestado.toString());
        if (state.nomeReferencia1 !== "") {
            data.append("nomeReferencia1", state.nomeReferencia1)
        }
        if (state.celularReferencia1) {
            data.append("celularReferencia1", state.celularReferencia1)
        }
        if (state.parentescoReferencia1) {
            data.append("parentescoReferencia1", state.parentescoReferencia1)
        }
        if (state.nomeReferencia2) {
            data.append("nomeReferencia2", state.nomeReferencia2)
        }
        if (state.celularReferencia2) {
            data.append("celularReferencia2", state.celularReferencia2)
        }
        if (state.parentescoReferencia2) {
            data.append("parentescoReferencia2", state.parentescoReferencia2)
        }

        if (state.crm) {
            data.append("crm", state.crm);
        }
        if (state.dataProtesto) {
            data.append("dataProtesto", state.dataProtesto);
        }

        for (const file of selectedFiles) {
            data.append("files", file);
        }


        setSelectedFiles([]);
        setPreview([]);

        return await api.put(props.url, data);
    }

    const handleSubmitForm = async () => {
        try {
            setLoading(true);

            const { notificationPerson, personToNotify } = getNotificationPersons();
            const personCompare = await api.get<IPessoa>(props.url);
            const response = await savePerson();

            if (personCompare.data.status !== eStatus.Ativo && state.status === eStatus.Ativo) {
                await NotificationRepository.Create({
                    descricao: getDescription(notificationPerson.role, notificationPerson.name),
                    mensagem: `O cadastro de ${notificationPerson.name} foi ativado.`,
                    recebedores: [{
                        recebedorId: personToNotify.id,
                        userLevel: personToNotify.role
                    }]
                });
            }

            toast(`🎉 ${response.data.message}`, { position: "top-center", type: "success" });
            setOpen(false);
            props.onSuccess();

        } catch (err) {
            const error = errors.getApiErrors(err.response.data)

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }

        setLoading(false);
    }

    const handleTransfer = async () => {
        try {
            const response = await resellersRepository.Transfer({
                id: state.id,
                transferPutModel: { representanteId: state.representanteId }
            });
            setOpen(false);
            props.onSuccess();
            toast(`💾 ${response.data.message}`, { position: "top-center", type: "success" });
        } catch (error) {
            return toast("❌ Erro ao transferir o revendedor.", { position: "top-center", type: "error" });
        }
    }

    const handleOpen = useCallback(() => {
        setOpen(true);
        setSelectedFiles([]);
        setPreview([]);
        load();
    }, [load]);

    useEffect(() => {
        if (!!props.open === false) return;
        handleOpen();
    }, [props.open, handleOpen]);

    const handleClose = () => {
        setState({ ...state, apiErrors: { errors: [] } });
        props.onSuccess();
        setOpen(false);
    }

    const hasError = (key: string) => {
        return errors.hasError(state.apiErrors, key);
    }

    const getMessage = (key: string) => {
        return errors.getMessage(state.apiErrors, key);
    }

    const getCep = async () => {
        try {
            const endereco = await cep(state.cep);

            setState({
                ...state,
                logradouro: endereco.street,
                bairro: endereco.neighborhood,
                cidade: endereco.city,
                uf: endereco.state
            });
        } catch (err) {
            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
    }

    const optionsStatus = [
        { key: "0", text: "INATIVO", value: 0, icon: "user times" },
        { key: "1", text: "ATIVO", value: 1, icon: "user" },
        { key: "2", text: "PENDENTE", value: 2, icon: "clock" },
        { key: "3", text: "PRÉ-APROVADO", value: 3, icon: "thumbs up" },
        { key: "4", text: "ANÁLISE", value: 4, icon: "search" },
        { key: "5", text: "REPROVADO", value: 5, icon: "dont" }
    ];

    const optionsDevedor = [
        { key: "0", text: "NÃO", value: 0, icon: "dont" },
        { key: "1", text: "SIM", value: 1, icon: "check circle" },
        { key: "2", text: "NEGOCIAÇÃO", value: 2, icon: "thumbs up" }
    ];

    const onDropdownChange = (event: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
        const { name, value } = data;
        setState(state => ({ ...state, [name]: value }));
    }

    const onChangeContrato = () => {
        setState(state => ({ ...state, contrato: !state.contrato }));
    }

    const onChangeProtestado = () => {
        setState(state => ({ ...state, protestado: !state.protestado }));
    }

    const onChangeRisco = () => {
        setState(state => ({ ...state, risco: !state.risco }));
    }

    function handleOnChangeInput(event: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) {
        setState(state => ({ ...state, [data.name]: data.value }));
    }
    function onChangeTextArea(event: React.FormEvent<HTMLTextAreaElement>, data: TextAreaProps) {
        setState(state => ({ ...state, [data.name]: data.value }));
    }
    function getNotificationPersons(): INotificationPersons {
        if (state.gerenteRegionalId) {
            return {
                personToNotify: {
                    id: state.gerenteRegionalId,
                    role: "GerenteR"
                },
                notificationPerson: {
                    id: state.id || "",
                    name: state.nome,
                    role: "GerenteS"
                }
            }
        }
        if (state.gerenteSetorId) {
            return {
                personToNotify: {
                    id: state.gerenteSetorId,
                    role: "GerenteS"
                },
                notificationPerson: {
                    id: state.id || "",
                    name: state.nome,
                    role: "Representante"
                }
            }
        }
        if (state.representanteId) {
            return {
                personToNotify: {
                    id: state.representanteId,
                    role: "Representante"
                },
                notificationPerson: {
                    id: state.id || "",
                    name: state.nome,
                    role: "Revendedor"
                }
            }
        }
        return {
            personToNotify: { id: "", role: "Admin" },
            notificationPerson: { id: "", name: "", role: "Admin" }
        };
    }

    const setWhatsApp = () => {
        const predefined = "https://api.whatsapp.com/send?phone=55";
        const contact = state.celular.replace("(", "").replace(")", "").replace("-", "");
        const message = "&text=Ol%C3%A1";
        return predefined + contact + message;
    }

    const isReadOnly = role !== "Admin" && !(state.status === eStatus.PreCadastro || state.status === eStatus.Pendente);

    const editarContent = (
        <Modal.Content scrolling>
            {
                (role === "Admin" && state.crm !== null) &&
                <Message
                    icon="warning sign"
                    warning
                    header='Atenção'
                    content='Possui anotações no CRM.'
                />
            }
            {
                (role === "Admin" || role === "GerenteS" || role === "Representante") &&
                <>
                    <Grid.Row>
                        <Grid.Column width="16">
                            <Tab
                                menu={{ secondary: true, pointing: true }}
                                panes={[{ menuItem: "Dados" }, { menuItem: "Crm" }, {
                                    menuItem:
                                        <Menu.Item as='a'> Histórico
                                        <Label color="black" floating>
                                                {kits.length}
                                            </Label>
                                        </Menu.Item>,
                                }, { menuItem: "Transferir" }]}
                                activeIndex={activeTabIndex}
                                onTabChange={handleTabChange}
                            />
                        </Grid.Column>
                    </Grid.Row>
                    <Divider />
                </>
            }
            {
                activeTabIndex === 0 &&
                <Form>
                    <Segment secondary>
                        <Label size="large" color="pink" attached="top"><Icon name="user circle" />Informações Pessoais</Label>
                        <Form.Group widths="equal">
                            <Form.Field width="16" error={hasError("Nome")} required>
                                <label>Nome</label>
                                <Input
                                    icon="user"
                                    iconPosition="left"
                                    name="nome"
                                    readOnly={role !== "Admin"}
                                    placeholder="Nome"
                                    value={state.nome}
                                    onChange={handleOnChangeInput}
                                />
                                {hasError("Nome") && <Label pointing prompt>{getMessage("Nome")}</Label>}
                            </Form.Field>
                            {!!state.representanteId === false &&
                                <Form.Field width={3} error={hasError("Consulta")} required>
                                    <label>Cód. Consulta</label>
                                    <Input
                                        name="consulta"
                                        readOnly={role !== "Admin"}
                                        placeholder="Cód. Consulta"
                                        value={state.consulta}
                                        onChange={handleOnChangeInput}
                                    />
                                    {hasError("Consulta") && <Label pointing prompt>{getMessage("Consulta")}</Label>}
                                </Form.Field>
                            }
                        </Form.Group>
                        <Form.Group>
                            <Form.Field width={4} error={hasError("Nascimento")} required>
                                <label>Data Nasc.</label>
                                <MaskedInput
                                    icon="birthday"
                                    iconPosition="left"
                                    name="nascimento"
                                    readOnly={role !== "Admin"}
                                    placeholder="Data Nasc."
                                    mask="data"
                                    value={state.nascimento}
                                    onChange={handleOnChangeInput}
                                />
                                {hasError("Nascimento") && <Label pointing prompt>{getMessage("Nascimento")}</Label>}
                            </Form.Field>
                            <Form.Field width={4} error={hasError("Cpf")} required>
                                <label>CPF</label>
                                <MaskedInput
                                    icon="id card"
                                    iconPosition="left"
                                    placeholder="CPF"
                                    readOnly={role !== "Admin"}
                                    name="cpf"
                                    mask="cpf"
                                    value={state.cpf}
                                    onChange={handleOnChangeInput}
                                />
                                {hasError("Cpf") && <Label pointing prompt>{getMessage("Cpf")}</Label>}
                            </Form.Field>
                            <Form.Field width={4} error={hasError("Rg")} required>
                                <label>RG</label>
                                <Input
                                    icon="vcard"
                                    iconPosition="left"
                                    name="rg"
                                    readOnly={isReadOnly}
                                    placeholder="RG"
                                    value={state.rg}
                                    onChange={handleOnChangeInput}
                                />
                                {hasError("Rg") && <Label pointing prompt>{getMessage("Rg")}</Label>}
                            </Form.Field>
                            <Form.Field width={4} error={hasError("Celular")} required>
                                <label>Celular</label>
                                <MaskedInput
                                    icon="call"
                                    iconPosition="left"
                                    name="celular"
                                    readOnly={isReadOnly}
                                    placeholder="Celular"
                                    mask="celular"
                                    value={state.celular}
                                    onChange={handleOnChangeInput}
                                    action={
                                        state.celular ?
                                            <Button
                                                circular
                                                as="a"
                                                color="green"
                                                target="_blank"
                                                icon="whatsapp"
                                                href={setWhatsApp()}
                                            />
                                            :
                                            undefined
                                    }
                                />
                                {hasError("Celular") && <Label pointing prompt>{getMessage("Celular")}</Label>}
                            </Form.Field>
                        </Form.Group>
                    </Segment>
                    <Segment secondary>
                        <Label size="large" color="pink" attached="top"><Icon name="street view" />Endereço</Label>
                        <Form.Group widths="equal">
                            <Form.Field width={3} error={hasError("Cep")} required>
                                <label>CEP</label>
                                <MaskedInput
                                    icon="map marker alternate"
                                    iconPosition="left"
                                    name="cep"
                                    readOnly={isReadOnly}
                                    placeholder="Cep"
                                    mask="cep"
                                    value={state.cep}
                                    onChange={handleOnChangeInput}
                                    onBlur={getCep}
                                />
                                {hasError("Cep") && <Label pointing prompt>{getMessage("Cep")}</Label>}
                            </Form.Field>
                            <Form.Field width={10} error={hasError("Logradouro")} required>
                                <label>Rua</label>
                                <Input
                                    icon="road"
                                    iconPosition="left"
                                    name="logradouro"
                                    readOnly={isReadOnly}
                                    placeholder="Rua"
                                    value={state.logradouro}
                                    onChange={handleOnChangeInput}
                                />
                                {hasError("Logradouro") && <Label pointing prompt>{getMessage("Logradouro")}</Label>}
                            </Form.Field>
                            <Form.Field width={3} error={hasError("Numero")} required>
                                <label>Número</label>
                                <Input
                                    icon="home"
                                    iconPosition="left"
                                    name="numero"
                                    readOnly={isReadOnly}
                                    placeholder="Número"
                                    value={state.numero}
                                    onChange={handleOnChangeInput}
                                />
                                {hasError("Numero") && <Label pointing prompt>{getMessage("Numero")}</Label>}
                            </Form.Field>
                        </Form.Group>
                        <Form.Group widths="equal">
                            <Form.Field width={4}>
                                <label>Complemento</label>
                                <Input
                                    icon="comment"
                                    iconPosition="left"
                                    name="complemento"
                                    readOnly={isReadOnly}
                                    placeholder="Casa, Fundos, Apt..."
                                    value={state.complemento}
                                    onChange={handleOnChangeInput}
                                />
                            </Form.Field>
                            <Form.Field width={6} error={hasError("Bairro")} required>
                                <label>Bairro</label>
                                <Input
                                    icon="industry"
                                    iconPosition="left"
                                    name="bairro"
                                    readOnly={isReadOnly}
                                    placeholder="Bairro"
                                    value={state.bairro}
                                    onChange={handleOnChangeInput}
                                />
                                {hasError("Bairro") && <Label pointing prompt>{getMessage("Bairro")}</Label>}
                            </Form.Field>
                            <Form.Field width={4} error={hasError("Cidade")} required>
                                <label>Cidade</label>
                                <Input
                                    icon="building"
                                    iconPosition="left"
                                    name="cidade"
                                    readOnly={isReadOnly}
                                    placeholder="Cidade"
                                    value={state.cidade}
                                    onChange={handleOnChangeInput}
                                />
                                {hasError("Cidade") && <Label pointing prompt>{getMessage("Cidade")}</Label>}
                            </Form.Field>
                            <Form.Field width={2} error={hasError("Uf")} required>
                                <label>Estado</label>
                                <Input
                                    icon="flag"
                                    iconPosition="left"
                                    name="uf"
                                    readOnly={isReadOnly}
                                    placeholder="Estado"
                                    value={state.uf}
                                    onChange={handleOnChangeInput}
                                />
                                {hasError("Uf") && <Label pointing prompt>{getMessage("Uf")}</Label>}
                            </Form.Field>
                        </Form.Group>
                    </Segment>
                    <Segment secondary>
                        <Label size="large" color="pink" attached="top"><Icon name="question circle" />Contatos de Referência</Label>
                        <Form.Group widths="equal">
                            <Form.Field error={hasError("NomeReferencia1")} required>
                                <label>Nome do Contato</label>
                                <Input
                                    icon="user"
                                    iconPosition="left"
                                    name="nomeReferencia1"
                                    readOnly={isReadOnly}
                                    placeholder="Nome"
                                    value={state.nomeReferencia1}
                                    onChange={handleOnChangeInput}
                                />
                                {hasError("NomeReferencia1") && <Label pointing prompt>{getMessage("NomeReferencia1")}</Label>}
                            </Form.Field>
                            <Form.Field error={hasError("CelularReferencia1")} required>
                                <label>Celular do Contato</label>
                                <MaskedInput
                                    icon="call"
                                    iconPosition="left"
                                    name="celularReferencia1"
                                    readOnly={isReadOnly}
                                    placeholder="Celular"
                                    mask="celular"
                                    value={state.celularReferencia1}
                                    onChange={handleOnChangeInput}
                                />
                                {hasError("CelularReferencia1") && <Label pointing prompt>{getMessage("CelularReferencia1")}</Label>}
                            </Form.Field>
                            <Form.Field error={hasError("ParentescoReferencia1")} required>
                                <label>Grau de Parentesco</label>
                                <Input
                                    icon="question circle"
                                    iconPosition="left"
                                    name="parentescoReferencia1"
                                    readOnly={isReadOnly}
                                    placeholder="Pai/Mãe/Tio"
                                    value={state.parentescoReferencia1}
                                    onChange={handleOnChangeInput}
                                />
                                {hasError("ParentescoReferencia1") && <Label pointing prompt>{getMessage("ParentescoReferencia1")}</Label>}
                            </Form.Field>
                        </Form.Group>
                        <Form.Group widths="equal">
                            <Form.Field error={hasError("NomeReferencia2")} required>
                                <label>Nome do Contato</label>
                                <Input
                                    icon="user"
                                    iconPosition="left"
                                    name="nomeReferencia2"
                                    readOnly={isReadOnly}
                                    placeholder="Nome"
                                    value={state.nomeReferencia2}
                                    onChange={handleOnChangeInput}
                                />
                                {hasError("NomeReferencia2") && <Label pointing prompt>{getMessage("NomeReferencia2")}</Label>}
                            </Form.Field>
                            <Form.Field error={hasError("CelularReferencia2")} required>
                                <label>Celular do Contato</label>
                                <MaskedInput
                                    icon="call"
                                    iconPosition="left"
                                    name="celularReferencia2"
                                    readOnly={isReadOnly}
                                    placeholder="Celular"
                                    mask="celular"
                                    value={state.celularReferencia2}
                                    onChange={handleOnChangeInput}
                                />
                                {hasError("CelularReferencia2") && <Label pointing prompt>{getMessage("CelularReferencia2")}</Label>}
                            </Form.Field>
                            <Form.Field error={hasError("ParentescoReferencia2")} required>
                                <label>Grau de Parentesco</label>
                                <Input
                                    icon="question circle"
                                    iconPosition="left"
                                    name="parentescoReferencia2"
                                    readOnly={isReadOnly}
                                    placeholder="Pai/Mãe/Tio"
                                    value={state.parentescoReferencia2}
                                    onChange={handleOnChangeInput}
                                />
                                {hasError("ParentescoReferencia2") && <Label pointing prompt>{getMessage("ParentescoReferencia2")}</Label>}
                            </Form.Field>
                        </Form.Group>
                    </Segment>
                    <Segment secondary>
                        <Label size="large" color="pink" attached="top"><Icon name="info" />Informações Adicionais</Label>
                        <Form.Group widths="equal">
                            {state.notificacao.mensagem.length > 0 && state.status === eStatus.Pendente &&
                                <Form.Field>
                                    <label>
                                        {role === "Admin" &&
                                            <Icon
                                                name={!!state.notificacao.recebedores.find(recebedor => recebedor.visualizada === true) ? "check" : "times"}
                                                color={!!state.notificacao.recebedores.find(recebedor => recebedor.visualizada === true) ? "pink" : "red"}
                                            />
                                        }
                                        Motivo pendente
                                    </label>
                                    <TextArea
                                        readOnly
                                        placeholder="Motivo pendente"
                                        name="mensagem"
                                        value={state.notificacao.mensagem}
                                    />
                                </Form.Field>
                            }
                        </Form.Group>
                        <Form.Group widths="equal">
                            {role === "Admin" && state.status === eStatus.Pendente &&
                                <>
                                    <Form.Field>
                                        <CadastroMotivoPendente
                                            personToNotify={getNotificationPersons().personToNotify}
                                            pendingPerson={getNotificationPersons().notificationPerson}
                                            onSuccess={load}
                                            onSavePerson={savePerson}
                                            disabled={role === "Admin" ? state.status !== eStatus.Pendente : false}
                                        />
                                    </Form.Field>
                                </>
                            }
                        </Form.Group>
                        <Form.Group widths="equal">
                            <Form.Field>
                                <Form.Dropdown
                                    fluid
                                    selection
                                    scrolling
                                    disabled={(role !== "Admin" && role !== "Operador")}
                                    name="status"
                                    label="Status"
                                    options={optionsStatus}
                                    value={state.status}
                                    onChange={onDropdownChange}
                                />
                            </Form.Field>
                            <Form.Field>
                                <Form.Dropdown
                                    fluid
                                    selection
                                    scrolling
                                    disabled={(role !== "Admin" && role !== "Operador")}
                                    name="devedor"
                                    label="Devedor"
                                    options={optionsDevedor}
                                    value={state.devedor}
                                    onChange={onDropdownChange}
                                />
                            </Form.Field>
                            {(role === "Admin" && state.protestado === true) &&
                                <>
                                    <Form.Field>
                                        <label>Data do Protesto:</label>
                                        <MaskedInputNew
                                            placeholder="Data do Protesto"
                                            mask="data"
                                            value={state.dataProtesto}
                                            onChange={(e: InputProps) => setState({ ...state, dataProtesto: e.target.value })} />
                                    </Form.Field>
                                </>
                            }
                        </Form.Group>
                        <Grid centered={false}>
                            <Grid.Column textAlign="center">
                                <Form.Field>
                                    <Form.Group widths="equal">
                                        <Form.Field>
                                            <label><Icon name="copy" />Contrato</label>
                                            <Checkbox
                                                disabled={(role !== "Admin" && role !== "Operador")}
                                                toggle
                                                onChange={onChangeContrato}
                                                checked={state.contrato}
                                            />
                                        </Form.Field>
                                        {
                                            role === "Admin" &&
                                            <Form.Field>
                                                <label><Icon name="times circle" />Risco</label>
                                                <Checkbox
                                                    toggle
                                                    onChange={onChangeRisco}
                                                    checked={state.risco}
                                                />
                                            </Form.Field>
                                        }
                                        <Form.Field>
                                            <label><Icon name="user times" />Protesto</label>
                                            <Checkbox
                                                disabled={(role !== "Admin")}
                                                toggle
                                                onChange={onChangeProtestado}
                                                checked={state.protestado}
                                            />
                                        </Form.Field>
                                    </Form.Group>
                                </Form.Field>
                            </Grid.Column>
                        </Grid>
                    </Segment>
                    <Segment secondary>
                        <Label size="large" color="pink" attached="top"><Icon name="images" />Fotos</Label>
                        <Form.Group widths="equal">
                            <Form.Field>
                                <p>
                                    <strong>
                                        FOTOS NECESSÁRIAS:<br />
                                        - RG; CPF; <br />
                                        - FOTO DE ROSTO SEGURANDO O DOCUMENTO;<br />
                                        - COMPROVANTE DE ENDEREÇO (ATUALIZADO);
                                            </strong>
                                </p>
                                <Button
                                    content="Anexar Fotos"
                                    icon="images"
                                    onClick={onButtonClick}
                                    color="blue"
                                    fluid
                                />
                                <input
                                    ref={fileInputRef}
                                    type="file"
                                    hidden
                                    multiple
                                    accept="image/*"
                                    onChange={onSelectFile}
                                />
                            </Form.Field>
                        </Form.Group>
                        <Form.Group>
                            <Grid columns={4} doubling>
                                {state.documentos.length > 0 &&
                                    state.documentos.map((x, index) =>
                                        <Grid.Column key={`image-${index}`}>
                                            <Image
                                                fluid
                                                label={<ImageZoom imagePath={`${api.defaults.baseURL}/images/${x.arquivo}`} />}
                                                src={`${api.defaults.baseURL}/images/${x.arquivo}`}
                                            />
                                            <ModalYesNo
                                                trigger={<Button icon="trash" color="red" attached="bottom" disabled={role !== "Admin"} />}
                                                header="Apagar"
                                                content="Deseja realmente apagar esta foto?"
                                                onSuccess={() => onRemove(x.id || "")}
                                            />
                                        </Grid.Column>
                                    )}
                                {preview.length > 0 &&
                                    preview.map((x, index) =>
                                        <Grid.Column key={`image-${index}`}>
                                            <Image
                                                fluid
                                                label={<ImageZoom imagePath={x} />}
                                                src={x}
                                            />
                                            <ModalYesNo
                                                trigger={<Button icon="trash" color="red" attached="bottom" />}
                                                header="Apagar"
                                                content="Deseja realmente apagar esta foto?"
                                                onSuccess={() => onRemovePreview(x, index)}
                                            />
                                        </Grid.Column>
                                    )}
                            </Grid>
                        </Form.Group>
                    </Segment>


                </Form>
            }
            {
                activeTabIndex === 1 &&

                <Form>
                    <Grid>
                        <Grid.Column>
                            {
                                (role === "Admin" || role === "GerenteS") ?
                                    <Form.Field>
                                        <label>Anotações pertinentes do cadastro:</label>
                                        <Form.TextArea
                                            rows={20}
                                            readOnly={role !== "Admin"}
                                            fluid
                                            placeholder="Digite as informações aqui..."
                                            name="crm"
                                            value={state.crm}
                                            onChange={onChangeTextArea}
                                        />
                                    </Form.Field>
                                    :
                                    <Message
                                        icon="dont"
                                        negative
                                        fluid
                                        header="Nível de acesso não permitido."
                                    />
                            }
                        </Grid.Column>
                    </Grid>
                </Form>
            }
            {
                activeTabIndex === 2 &&
                <Form>
                    <Grid textAlign="center">
                        <Grid.Column>
                            {kits.length === 0 &&
                                <Message
                                    negative
                                    fluid
                                    header="Nenhum kit vinculado ao revendedor."
                                />
                            }
                            <Grid.Row>
                                {kits.map(kit => {
                                    return <>
                                        {kit.status === eStatusKit.Revendedora ?
                                            <Message
                                                icon="street view"
                                                color="teal"
                                                content={
                                                    <>
                                                        <Grid columns="equal">
                                                            <Grid.Row>
                                                                <Grid.Column>
                                                                    <Grid.Row>
                                                                        <strong>Kit</strong>
                                                                    </Grid.Row>
                                                                    <Grid.Row>
                                                                        {kit.numero}
                                                                    </Grid.Row>
                                                                </Grid.Column>
                                                                <Grid.Column>
                                                                    <Grid.Row>
                                                                        <strong>Entregue</strong>
                                                                    </Grid.Row>
                                                                    <Grid.Row>
                                                                        {format(new Date(kit.dataEntrega), "dd/MM/yyyy")}
                                                                    </Grid.Row>
                                                                </Grid.Column>
                                                                <Grid.Column>
                                                                    <Grid.Row>
                                                                        <strong>Prox. Acerto</strong>
                                                                    </Grid.Row>
                                                                    <Grid.Row>
                                                                        {format(new Date(kit.acerto), "dd/MM/yyyy")}
                                                                    </Grid.Row>
                                                                </Grid.Column>
                                                                <Grid.Column>
                                                                    <Grid.Row>
                                                                        <strong>Tipo</strong>
                                                                    </Grid.Row>
                                                                    <Grid.Row>
                                                                        {kit.tipo === 0 ? "Novo" : "Acerto"}
                                                                    </Grid.Row>
                                                                </Grid.Column>
                                                                {
                                                                    role === "Admin" &&
                                                                    <Grid.Column>
                                                                        <EditarKit key={`kits_edit_${kit.id}`} kitId={kit.id || ""} onSuccess={load} />
                                                                    </Grid.Column>
                                                                }
                                                            </Grid.Row>
                                                        </Grid>
                                                    </>
                                                }
                                            />
                                            :
                                            <Message
                                                positive={kit.estado === eEstado.Normal}
                                                negative={kit.estado === eEstado.Devendo}
                                                icon={kit.estado === eEstado.Normal
                                                    ? "check circle"
                                                    : kit.estado === eEstado.Devendo ? "user times" : "thumbs down"}
                                                content={
                                                    <>
                                                        <Grid columns="equal">
                                                            <Grid.Row>
                                                                <Grid.Column>
                                                                    <Grid.Row>
                                                                        <strong>Kit</strong>
                                                                    </Grid.Row>
                                                                    <Grid.Row>
                                                                        {kit.numero}
                                                                    </Grid.Row>
                                                                </Grid.Column>
                                                                <Grid.Column>
                                                                    <Grid.Row>
                                                                        <strong>Acerto</strong>
                                                                    </Grid.Row>
                                                                    <Grid.Row>
                                                                        {format(new Date(kit.acerto), "dd/MM/yyyy")}
                                                                    </Grid.Row>
                                                                </Grid.Column>
                                                                {
                                                                    kit.estado !== eEstado.NaoRetornou &&
                                                                    <Grid.Column>
                                                                        <Grid.Row>
                                                                            <strong>Venda Bruta</strong>
                                                                        </Grid.Row>
                                                                        <Grid.Row>
                                                                            {numberFormat.Currency(kit.valorVendido)}
                                                                        </Grid.Row>
                                                                    </Grid.Column>
                                                                }
                                                                {
                                                                    kit.estado !== eEstado.Normal &&
                                                                    <Grid.Column>
                                                                        <Grid.Row>
                                                                            <strong>Débito</strong>
                                                                        </Grid.Row>
                                                                        <Grid.Row>
                                                                            {
                                                                                kit.estado === eEstado.Devendo
                                                                                    ? numberFormat.Currency(kit.valorDebito)
                                                                                    : numberFormat.Currency(kit.valor)
                                                                            }
                                                                        </Grid.Row>
                                                                    </Grid.Column>
                                                                }
                                                                <Grid.Column>
                                                                    <Grid.Row>
                                                                        <strong>Tipo</strong>
                                                                    </Grid.Row>
                                                                    <Grid.Row>
                                                                        {kit.tipo === eTipoKit.Novo ? "Novo" : "Acerto"}
                                                                    </Grid.Row>
                                                                </Grid.Column>
                                                                {
                                                                    role === "Admin" &&
                                                                    <Grid.Column>
                                                                        <EditarKit key={`kits_edit_${kit.id}`} kitId={kit.id || ""} onSuccess={load} />
                                                                    </Grid.Column>
                                                                }
                                                            </Grid.Row>
                                                        </Grid>
                                                    </>
                                                }
                                            />
                                        }
                                    </>
                                })}
                            </Grid.Row>
                        </Grid.Column>
                    </Grid>
                </Form>
            }
            {
                activeTabIndex == 3 &&
                <>
                    <Segment>
                        <Grid>
                            {
                                role === "Admin" ?
                                    <Grid.Column width="16">
                                        {
                                            state.status <= 2 &&
                                            <Message
                                                size="small"
                                                header="Não pode ser transferido!"
                                                icon="dont"
                                                color="grey"
                                            />
                                        }
                                        {
                                            state.status >= 3 &&
                                            <Form>
                                                <Form.Group>
                                                    <Form.Field width="16">
                                                        <Form.Dropdown
                                                            fluid
                                                            selection
                                                            search
                                                            scrolling
                                                            label="Selecione o novo representante"
                                                            disabled={state.status === 0 || state.status === 1}
                                                            name="representanteId"
                                                            noResultsMessage="Nenhum registro encontrado."
                                                            placeholder="Selecione o novo representante"
                                                            onChange={onDropdownChange}
                                                            options={agents.map(agent => { return { key: agent.id, value: agent.id, text: agent.nome } })}
                                                            value={state.representanteId}
                                                            clearable
                                                        />
                                                    </Form.Field>
                                                </Form.Group>
                                                <br />
                                                <br />
                                                <Form.Group>
                                                    <Form.Field width="16">
                                                        <ModalYesNo
                                                            trigger={
                                                                role === "Admin" &&
                                                                <Button
                                                                    fluid
                                                                    disabled={!state.representanteId}
                                                                    content="transferir"
                                                                    icon="exchange"
                                                                    color="red"
                                                                />
                                                            }
                                                            header="Atenção"
                                                            content={`Deseja realmente realizar a transferencia?`}
                                                            onSuccess={() => handleTransfer()}
                                                        />
                                                    </Form.Field>
                                                </Form.Group>
                                            </Form>
                                        }

                                    </Grid.Column>
                                    :
                                    <Message
                                        icon="dont"
                                        negative
                                        fluid
                                        header="Nível de acesso não permitido."
                                    />
                            }
                        </Grid>
                    </Segment>

                </>
            }
        </Modal.Content >
    );

    return (
        <ModalApp
            open={open}
            loading={loading}
            handleOpen={handleOpen}
            handleClose={handleClose}
            title="Editar"
            content={loading ? <CustomLoader /> : editarContent}
            trigger={!!props.hideTrigger
                ? undefined
                : {
                    icon: "pencil",
                    color: "blue"
                }
            }
            onSuccess={{ content: "Salvar", func: handleSubmitForm }}
        />
    );
};

export default EditarPessoa;
